import { Route } from '@angular/router';
import { AGENT_ROLES } from '@app/core/services/http/auth/auth.service';

/** Кабинет агента (роль PARTNER_AGENT) */
export const agentRoutes: Route = {
  path: 'agent',
  // advertisingOnlyAccess — доступно агенту «Только реклама» (RoleGuard пускает его только сюда)
  data: { roles: [...AGENT_ROLES], advertisingOnlyAccess: true },
  children: [
    { path: '', pathMatch: 'full', redirectTo: 'marketing' },
    {
      path: 'marketing',
      loadComponent: () =>
        import('./agent-marketing/agent-marketing.component').then(m => m.AgentMarketingComponent),
    },
  ],
};
